<template>
    <div>
        <div class="col-md-12">
            <b-form class="form-inline mt-3">
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" v-model="status" :options="statusOptions"></b-form-select>


                <b-form-datepicker  class="mb-2 mr-sm-2 mb-sm-0" v-model="startDate" ></b-form-datepicker>
                <b-form-datepicker  class="mb-2 mr-sm-2 mb-sm-0" v-model="endDate" ></b-form-datepicker>

                <b-form-radio-group
                        class="ml-auto mr-3"
                        v-model="period"
                        :options="periodOptions"
                        buttons
                        name="radios-btn-default">
                </b-form-radio-group>

                <b-btn @click="getActions" class="btn btn-info mb-2 mr-sm-2 mb-sm-0">Search</b-btn>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <b-table v-else striped hover class="mt-3" :items="actions"></b-table>
        <b-alert :show="actions.length === 0" variant="warning">Not found</b-alert>

    </div>
</template>

<script>
    import GetDriverTripActions from "../../../../../store/actions/getDriverTripActions";
    import ContentLoader from "../../../../../components/ContentLoader";
    import ShowError from "../../../../../helpers/showError";

    const today = new Date();

    export default {
        name: 'DriverActionStatusComponent',
        components: {
            loader: ContentLoader,
        },
        data: () => ({
            loading: false,
            startDate: new Date(today.getFullYear(), today.getMonth(), 1),
            endDate: today,
            period: 'day',
            periodOptions: [
                {text: 'Daily', value: 'day'},
                {text: 'Weekly', value: 'week'},
                {text: 'Monthly', value: 'month'},
            ],
            status: 'DRIVER_REJECTED',
            statusOptions: ['DRIVER_REJECTED', 'DRIVER_TIMEOUT', 'DRIVER_CANCELLED', 'DRIVER_REQUESTED', 'FINISHED'],
            actions: []
        }),
        created() {
            this.getActions();
        },
        methods: {
            async getActions() {
                try{
                    this.loading = true;
                    const actions = await GetDriverTripActions({
                        userId: this.$route.params.id,
                        startDate: this.startDate,
                        endDate: this.endDate,
                        period: this.period,
                        status: this.status
                    });

                    this.actions = actions.map(action => {
                        action.period = new Date(action.period).toLocaleDateString();

                        return Object.assign({status: this.status}, action);
                    })
                }
                catch (e) {
                    ShowError(this, e);
                }
                finally {
                    this.loading = false;
                }
            }
        }
    }
</script>